import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { ApiService, DatastoreService } from 'src/app/services';

@Component({
  selector: 'app-no-booking',
  templateUrl: './no-booking.component.html',
  styleUrls: ['./no-booking.component.scss']
})
export class NoBookingComponent implements OnInit {
  params: any;
  noBookings: any;
  config: any;
  reg: string = "";
  diy: boolean = false;
  status: any;
  tableData: any;
  searchText: string;
  unfilteredBookings: any;
  userActivity: any;
  isInactive: boolean;
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private dataStore: DatastoreService,
  ) { }

  ngOnInit(): void {
    this.params = this.route.snapshot.params
    if (this.dataStore.config) {
      this.config = JSON.parse(this.dataStore.config)
    } else {
      this.router.navigate([`/${this.params.site}/${this.params.comp}`])
    }
    this.tableData = this.config.set["noBooking"]
    console.log(this.config.set)
    console.log(this.tableData)
    this.getNoBookings()
    this.dataStore.refresher = setInterval(() => {
      if (this.dataStore.refreshTimer > 60 * 15 && this.isInactive) {
        this.dataStore.refreshTimer = 0
        this.refresh()
        this.dataStore.refreshTimer = 0
      }
    }, 1000);
  }



  // if user does anything, reset inactivity
  @HostListener('window:click') refreshUserStateClick() {
    this.resetInactivity()
  }
  @HostListener('window:mousemove') refreshUserStateMove() {
    this.resetInactivity()
  }
  @HostListener('window:keydown') refreshUserStateKey() {
    this.resetInactivity()
  }
  @HostListener('window:wheel') refreshUserStateScroll() {
    this.resetInactivity()
  }

  resetInactivity() {
    this.isInactive = false;
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.isInactive = true, 3000);
  }

  async refresh(){
    await this.getNoBookings()
    await this.search()
  }

  

  search() {
    if (this.searchText === "") {
      this.noBookings = JSON.parse(JSON.stringify(this.unfilteredBookings))
    } else {
      let filteredBookings = this.unfilteredBookings.filter((x: any) => {
        console.log(x.booking)
        let match = false
        // if (x.booking.id.toString().toLowerCase().includes(this.searchText.toLowerCase())) match = true
        for (let tab of this.tableData.tabs) {
          const dataForTable = this.getDataForTable(x, tab);
          if (dataForTable) {
            if (dataForTable.toString().toLowerCase().includes(this.searchText.toLowerCase())) match = true;
          }
        }
        return match
      })
      this.noBookings = filteredBookings
    }
  }

  async getNoBookings() {
    console.log(this.dataStore.loginObject.member)
    let bookings: any = await this.apiService.getNoBookings(this.dataStore.loginObject.member.company_id, moment().locale('en').format('YYYY-MM-DD'), this.config.staging)
    bookings.sort((x1: any, x2: any) => {
      const x1DataPoint = this.getDataForTable(x1, this.tableData.filter)
      const x2DataPoint = this.getDataForTable(x2, this.tableData.filter)
      console.log(this.tableData.filter.format)
      if (this.tableData.filter.format === "dateTime") {

        const x1Date: any = moment(moment().format("YYYY-MM-DD") + " " + this.getDataForTable(x1,  {data:['time']}) )
        const x2Date: any = moment(moment().format("YYYY-MM-DD") + " " + this.getDataForTable(x2,  {data:['time']}) )
        return x1Date - x2Date
      }
      return x1DataPoint - x2DataPoint
    })
    this.unfilteredBookings = bookings
    this.dataStore.tabNoBookingCount = this.unfilteredBookings.length

    this.noBookings = JSON.parse(JSON.stringify(this.unfilteredBookings))
    console.log(this.noBookings)
  }

  async submitNoBooking() {
    console.log("submitted ", this.reg, this.diy)

    await this.apiService.addNoBooking(this.dataStore.loginObject.member.company_id, this.dataStore.loginObject.member.company_name, this.reg, this.diy, this.config.staging)
    this.reg = ""
    this.diy = false
    await this.getNoBookings()
  }


  getDataForTable(data: any, tab: any) {
    const keyArray = tab.data
    let out = data;
    for (let key of keyArray) {
      if (out !== undefined) {
        if (key.filterKey) {
          out = out.filter((x: { [x: string]: { toString: () => any; }; }) => x[key.filterKey].toString() === key.filterValue.toString())[0]
        } else {
          out = out[key]
        }
      }
    }
    if (tab.format === "date") {
      out = moment(out).format("DD/MM/YYYY")
    }
    if (tab.format === "time") {
      out = moment(out).format("HH:mm")
    }
    if (out === undefined) {
      out = "-"
    }

    if (keyArray[1] === "answers_summary" && keyArray[2].filterValue) {

      out = this.convertIfBool(data, keyArray[2].filterValue.toString(), out)
    }

    if (tab.showFlagForAnswers) {
      if (tab.showFlagForAnswers.includes(out)) {
        let tempOut = out;
        out = `
        <div class="govuk-warning-text warning-cell">
          <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
          <strong class="govuk-warning-text__text">
            <span class="govuk-warning-text__assistive">Warning</span>
          </strong>
        </div>`;
      } else {
        out = ""
      }
    }

    return out;
  }


  convertIfBool(data: any, id: string, out: any) {
    const question = data.service.bookingQuestions.filter((x: { [x: string]: { toString: () => any; }; }) => {
      return x.id.toString() === id
    })[0]
    if (question) {
      if (question.detail_type === "check") {
        if (out === "1" || out === "true") {
          out = "Yes"
        }
        if (out === "0" || out === "false" || out === false || out === "-") {
          out = "No"
        }
      }
    }
    return out;
  }
}
